import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/utils/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
})
export class DropDownComponent implements OnInit, OnDestroy, OnChanges {
  subscription: Subscription | undefined;
  sharedData: any;
  selectedId: string | undefined;
  selectedZone: string | undefined;
  selected: string | undefined;
  @Input() sites: any | undefined;

  constructor(
    public sharedDataService: SharedDataService,
    private changeDetectorRef: ChangeDetectorRef,
    private commonService: CommonService,
    private router: Router
  ) {}

  /**
   * @description: runs on when component is initialized. This method subscribes sharedDataService,
   *               and set the selected site of shared-data-service.
   * @input {none}
   * @output {void}
   */

  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        if (sharedData?.selectedSite?.siteName === '')
          this.selected = undefined;
        else this.selected = sharedData?.selectedSite?.siteName;
        this.changeDetectorRef?.detectChanges();
      }
    );

    if (
      this.sites?.length > 0 &&
      this.sharedData?.selectedSite?.siteName === '' &&
      this.sharedData?.selectedSite?.siteId === ''
    ) {
      this.selected = this.sites[0]?.siteName;
      this.sharedDataService.setSelectedSite({
        siteName: this.sites[0]?.siteName,
        siteId: this.sites[0]?.siteId,
        siteTimeZone: this.sites[0]?.siteTimeZone,
        commonAccessControl: this.sites[0]?.commonAccessControl,
      });
    }
  }

  /**
   * @description: runs on when component is initialized. This method subscribes sharedDataService,
   *               and set the selected site of shared-data-service.
   * @input {SimpleChanges}
   * @param { changes }
   * @output {void}
   */

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.sites?.currentValue?.length > 0 &&
      (this.sharedData?.selectedSite?.siteName === '' ||
        this.sharedData?.selectedSite?.siteName === null)
    ) {
      this.selected = this.sites[0]?.siteName;
      this.sharedDataService.setSelectedSite({
        siteName: this.sites[0]?.siteName,
        siteId: this.sites[0]?.siteId,
        siteTimeZone: this.sites[0]?.siteTimeZone,
        commonAccessControl: this.sites[0]?.commonAccessControl
      });
    }
  }

  /**
   * @description: onSelect method perform selection of site from sitelist in drop-down and
   *               set the setSelectedSite and remove the selection of subsequent floors and
   *               unit.
   * @input { none }
   * @output { String }
   */

  onSelect(id: string, value: string, siteTimeZone: string, commonAccessControl: boolean) {
    if (this.selected !== value) {
      this.selected = value;
      this.selectedId = id;
      this.selectedZone = siteTimeZone;
      this.sharedDataService.setSelectedSite({
        siteName: value,
        siteId: id,
        siteTimeZone: siteTimeZone,
        commonAccessControl: commonAccessControl
      });
      this.sharedDataService.setSelectedUnit({
        unitName: null,
        unitId: null,
      });
      this.sharedDataService.setSelectedFloor({
        floorId: null,
        floorName: null,
      });
      /** when site id change need to redirect user to dahboad */
      if (this.router?.url?.includes('dashboard/users')) {
        this.router.navigate(['/dashboard']);
      }
      this.commonService.setDashboardStatistics(this.selectedId);
    }
  }

  /**
   * @description: runs just before component unmount. Unsubscribes the login service
   * @input {none}
   * @output {void}
   */

  ngOnDestroy(): void {
    this.sharedDataService.setSelectedSite({
      siteName: '',
      siteId: '',
      siteTimeZone: '',
      commonAccessControl: true
    });
    this.subscription?.unsubscribe();
  }
}
